import React, { useContext, useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from '@mui/material';

import { useFetch } from '../auth/useFetch';

import ProjectContext from '../../contexts/ProjectContext';

import ItemList from '../menuitem/ItemList';


export default function SelectExportsDialog(props) {
    const { open, setOpen, anchorEl, downloadExport } = props
    const { isAuthenticated } = useAuth0();

    const fetchWithAuth = useFetch()
    const projectContext = useContext(ProjectContext);

    const [exports, setExports] = useState([])

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        const url = `${process.env.REACT_APP_BACKEND_URL}/konsol/exportale`
        isAuthenticated && (async () => {
        try {
            await fetchWithAuth(url, {
                headers: {
                    'X-Project-ID': projectContext?.project_db
                },
            })
                .then((response) => response.json())
                .then((res) => {
                    setExports(res.filter((item) => {return item.type === 'ALE' || item.type === 'CSV' || item.type === 'PDF'}))
                })
        } catch (e) {
            console.error(e);
        }
        })();
    }, [isAuthenticated])

    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="lg"
                PaperProps={{
                    sx: {
                        width: "auto",
                        height: "auto",
                        backgroundColor: "#282828",
                    },
                }}
            >
                <DialogTitle>Available Exports</DialogTitle>
                <DialogContent>
                    <Box sx={{ width: '400px', height: '400px', overflow: 'auto' }}>
                        {exports.map((exp, index) => {
                            return (
                                <ItemList
                                    key={index}
                                    title={exp['name']} 
                                    label={exp['type']} 
                                    onItemClick={() => downloadExport(exp)}
                                />
                            )
                        })}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} sx={{ color: 'white' }}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}